import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SurveyQuestionOption } from '../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../general-ui/icon';
import { RadioInput } from '../../../../../general-ui/radio-group/radio';
import BasicInput from '../../../../../general-ui/text-input/basic-input';
import './quiz-option.scss';

interface QuizOptionProps {
	Handlers: { [key: string]: any };
	id: string;
	index: number;
	onCheckCorrect: (option: SurveyQuestionOption) => void;
	onDelete: () => void;
	option: SurveyQuestionOption;
}

export function QuizOption({ Handlers, id, index, option, onCheckCorrect, onDelete }: QuizOptionProps) {
	const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform } = useSortable({
		id,
	});
	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};

	const handleCheckCorrect = () => {
		onCheckCorrect(option);
	};

	return (
		<div
			className="survey-quiz-question-option"
			ref={setNodeRef}
			style={style}
		>
			<div
				className="drag-handle"
				ref={setActivatorNodeRef}
				{...attributes}
				{...listeners}
			>
				<Icon
					name={ICONS.DRAG_HANDLE}
					size={18}
					color={COLORS.DEFAULT_GRAY}
				/>
			</div>
			<div className="survey-quiz-question-option-data">
				<RadioInput
					ariaLabel={option.label.base}
					onClick={handleCheckCorrect}
					selected={!!option.is_correct}
				/>
				<BasicInput
					placeholder={'Enter option text'}
					margin="none"
					onChange={Handlers.setOptionLabel(index)}
					value={option.label.base ?? ''}
					className="survey-quiz-question-option-input"
				/>
			</div>
			<div
				className="survey-question-quiz-delete"
				onClick={onDelete}
			>
				<Icon
					name={ICONS.CLOSE}
					size={16}
					color={COLORS.WHITE}
				/>
			</div>
		</div>
	);
}
